import React from "react";
import './Slidebar.css';
import {
 
 
  FaFacebookF,
  FaGithub,
 
  FaLinkedinIn,
  FaSkype,
  FaTwitter,
} from "react-icons/fa";
import profile from "../../../images/hafiz_row.jpg";


const socials = [
  {
    id: 1,
    icon: <FaFacebookF />,
    link: "https://web.facebook.com/okshihafiz",
  },
  {
    id: 2,
    icon: <FaGithub />,
    link: "https://github.com/okshihafiz",
  },
  {
    id: 3,
    icon: <FaLinkedinIn />,
    link: "https://www.linkedin.com/in/hafizur-rahman-jr/",
  },
 
  {
    id: 4,
    icon: <FaSkype />,
    link: "https://join.skype.com/invite/uwPI61pfWsxA",
  },
  {
    id: 5,
    icon: <FaTwitter />,
    link: "https://twitter.com/hafizur_jr",
  },
];

const Sidebar = () => {
  return (
    <aside className="sticky top-0 bg-white md:mx-8 lg:mx-7 mb-8 p-6 shadow-md rounded-md -mt-40">
      <div className=" overflow-hidden mx-auto mb-5">
        <img style={{width:'70%', margin:'0 auto'}}  src={profile} alt="shafiqhammad" className="w-full" />
      </div>
      <div className="text-center">
        <h1 className="text-xl text-gray-800 font-bold mb-1">Hafizur Rahman</h1>
        <p className="text-sm text-gray-400 mb-3">
          Frontend Web Developer 
          {/* <a href="#0" className="text-purple-600 pl-1">
            Abc Company
          </a> */}
        </p>
        <a
        style={{background:'#171717'}}
          href="https://docs.google.com/document/d/1hXHICz3wbqWKFGVY9aEo_hJ4nPdwiyEK1HDPspq1KTM/export?format=pdf"
          className="inline-block mb-3 rounded  text-center border-0 py-2 px-6 text-white leading-7 tracking-wide hover:bg-purple-800"
          
        >
          Download Resume
        </a>
        <ul className="flex flex-wrap justify-center">
          {socials.map((social, id) => (
            <SocialIcon social={social} key={id} />
          ))}
        </ul>
      </div>
      <div className="text-start pt-4">
        <h3 className="text-md mb-2 uppercase font-medium text-gray-800">
          About Dev
        </h3>
        <p style={{fontSize:'16px', color:'#171717', fontFamily:'sans-serif', textAlign:'justify'}} className="text-gray-400 text font-light leading-relaxed">
        Developers always try to make difference from his/her previous work. It is the theory of the developer's life. They are always ready to explore, take challenges and make the easiest way to upcoming technologies. They are the real fighter who has always struggle with a bunch of error and at last, give you a present like a ton of technology
        </p>
      </div>

      <div style={{marginTop:'30px'}}>
        <form action="https://formspree.io/f/mwkyeqev" method="POST">
            <textarea className="postBox" rows="10" cols="28" type="text" placeholder="What is your message" required></textarea>
            <input className="InputBox" type="email" name="email" id="" placeholder="Enter your email"  required/>
            <button className="postBtn">Post</button>
        </form>
      </div>
    </aside>
  );
};

export default Sidebar;

const SocialIcon = (props) => {
  const { icon, link } = props.social;
  return (
    <>
      <li style={{marginTop:'60px', marginBottom:'60px'}} className="m-2">
      <a
        href={link}
        className="w-8 h-8 bg-purple-100 rounded  flex items-center justify-center "
      >
        {icon}
      </a>
    </li>
    
    </>
  );
};
